<template>
  <div>
    <v-row>
      <v-col cols="12" md="8" lg="6">
        <SalesFunnel :items="sf_items" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {reactive} from "@vue/composition-api";
import SalesFunnel from "@/components/lead/marketplace/funnel/SalesFunnel";

export default {
  name: "SalesFunnelView",
  components: {
    SalesFunnel
  },
  setup() {
    const sf_items = reactive([
        {
          id: 0,
          title: 'Gewonnen',
          highlight: true,
          value: '3 / 14'
        },
        {
          id: 1,
          title: 'Angebot',
          highlight: false,
          value: '8'
        },
        {
          id: 2,
          title: 'Präsentation',
          highlight: false,
          value: '10'
        },
        {
          id: 3,
          title: 'Buying-Center involvieren',
          highlight: false,
          value: '14'
        },
        {
          id: 4,
          title: 'Projekt etablieren',
          highlight: false,
          value: '16'
        },
        {
          id: 5,
          title: 'Bedarfsanalyse',
          highlight: false,
          value: '33'
        },
        {
          id: 6,
          title: 'Kontaktaufnahme',
          highlight: false,
          value: '66'
        },
      ]);

    return {sf_items};
  }
}
</script>

<style scoped lang="scss">

</style>
